/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ClientReportByMailRequest { 
    emailsTo?: Array<string>;
    emailsCc?: Array<string>;
    emailsBcc?: Array<string>;
    contractNoticeIds?: Array<string>;
    contractAnnouncementAsNoticeIds?: Array<string>;
    contractAnnouncementIds?: Array<string>;
    bankruptcyIds?: Array<string>;
    saleIds?: Array<string>;
    lang?: ClientReportByMailRequest.LangEnum;
}
export namespace ClientReportByMailRequest {
    export type LangEnum = 'MK' | 'EN' | 'AL';
    export const LangEnum = {
        MK: 'MK' as LangEnum,
        EN: 'EN' as LangEnum,
        AL: 'AL' as LangEnum
    };
}